<template>
  <div :class="['communication',isEndLogin?'loginEnd':'myNewstyle']">
    <!-- <navtab class="navTab" v-on:select="select" ></navtab> -->
    <navtab v-on:select="select" class="navTab"></navtab>
        <!-- <iframe src="http://115.29.185.211:8033/huban-dcfadmin/modules/app/im.html?id=170320179724117116&token=201905302045205901&username=13606509653" frameborder="0"  scrolling="no" id="screen"></iframe> -->
        <iframe v-show="isEndLogin" :src='url+ "?id="+id+"&token="+token+"&username="+username' frameborder="0"  scrolling="no" id="screen"></iframe>
        <!-- <div class="address" v-html="htmlWord"></div> -->
            <!-- 登录 -->
    <div class="loginPart" v-if="isSelect==1" v-show="!isEndLogin">
      <div class="onlyLef">
        <div class="loginHead">
          <img src="../assets/loginLogo.png" alt />
        </div>
        <!-- <div class="backIndexDiv" @click="backToIndex">
          <img src="../assets/indexback.png" alt />
          <p>返回首页</p>
        </div> -->
      </div>
      <div class="onlyRig">
        <!-- <span class="el-icon-close" id="close" @click="cancelLogin()"></span> -->
        <ul class="loginNav">
          <li @click="notRegister()" :class="currentNum==1?'style':''">登录</li>
          <li @click="isRegister()" :class="currentNum==2?'style':''">注册</li>
        </ul>
        <ul class="loginInput">
          <li>
            <input type="text" placeholder="请输入手机号码" v-model="loginAdmin" />
          </li>
          <li>
            <input type="password" placeholder="请输入密码" v-model="loginPassword" />
          </li>
        </ul>
        <div class="newDiv">
          <div class="newDivLeft" @click="rememberPw">
            <input class="radioInput" :checked="chooseAll" type="checkbox" />
            <p>记住密码</p>
          </div>
          <span class="forgetPassword" @click="forgetPasswordEvent()">忘记密码？</span>
        </div>
        <div class="loginBtn" @click="loginEvent()">登 录</div>
        <p class="newP" @click="nowToRegister()">
          <span>还未注册，现在就</span>
          <span id="newSpan">注册</span>
        </p>
      </div>
    </div>
    <!-- 注册 -->
    <div class="loginPart" v-if="isSelect==2" v-show="!isEndLogin">
      <!-- <span class="el-icon-close" id="close" @click="cancelLogin()"></span> -->
      <div class="onlyLef">
        <div class="loginHead" v-show="!isforget">
          <el-upload
            class="avatar-uploader"
            action="http://192.168.1.240:8080/huban-dcfadmin/file/upload"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <!-- <img v-if="imageUrl" :src="imageUrl" class="avatar" /> -->
            <!-- <i v-else class="el-icon-plus avatar-uploader-icon addHeadImg"></i> -->
            <img :src="imageUrl?imageUrl:newImageUrl" class="avatar" />
          </el-upload>
        </div>
        <!-- <div class="backIndexDiv" @click="backToIndex">
          <img src="../assets/indexback.png" alt />
          <p>返回首页</p>
        </div> -->
      </div>
      <div class="onlyRig">
        <ul class="loginNav">
          <li @click="notRegister()" :class="currentNum==1?'style':''">登录</li>
          <li @click="isRegister()" :class="currentNum==2?'style':''">注册</li>
        </ul>
        <ul class="loginInput">
          <li>
            <input type="text" placeholder="请输入手机号码" v-model="registerAdmin" />
          </li>
          <li>
            <input type="text" placeholder="请输入验证码" v-model="checkNum" />
          </li>
          <li>
            <input type="password" placeholder="请输入密码" v-model="registerPassword" />
          </li>
          <li>
            <input type="password" placeholder="请确认密码" v-model="aginPassword" />
          </li>
          <li id="getKey" @click="getKey(registerType,registerAdmin)">获取验证码</li>
        </ul>
        <div class="loginBtn" v-show="!isforget" @click="register()">注 册</div>
        <div class="loginBtn" v-show="isforget">完 成</div>
      </div>
    </div>
    <!-- 忘记密码 -->
    <div class="loginPart" v-if="isSelect==3" v-show="!isEndLogin">
      <!-- <span class="el-icon-close" id="close" @click="cancelLogin()"></span> -->
      <div class="onlyLef">
        <div class="loginHead">
          <img src="../assets/index.png" alt />
        </div>
        <!-- <div class="backIndexDiv" @click="backToIndex">
          <img src="../assets/indexback.png" alt />
          <p>返回首页</p>
        </div> -->
      </div>
      <div class="onlyRig">
        <ul class="loginNav">
          <li>忘记密码</li>
        </ul>
        <ul class="loginInput">
          <li>
            <input type="text" placeholder="请输入手机号码" v-model="forgetAdmin" />
          </li>
          <li>
            <input type="text" placeholder="请输入验证码" v-model="checkNum" />
          </li>
          <li>
            <input type="password" placeholder="请输入密码" v-model="forgetPassword" />
          </li>
          <li>
            <input type="password" placeholder="请确认密码" v-model="forgetAginPassword" />
          </li>
          <li id="getKey" @click="getKey(forgetType,forgetAdmin)">获取验证码</li>
        </ul>
        <div class="loginBtn" @click="forget()">完 成</div>
      </div>
    </div>
  </div>
</template>

<script>
import navtab from "./navtab";
import $ from 'jquery';
export default {
  name: "communication",
  components: {
    navtab: navtab
  },
  inject: ["reload"],
  data() {
    return {
      //  htmlWord:
      // "Copyright&nbsp©&nbsp2016-2019&nbsp浙江桃园科技有限公司&nbsp&nbsp|&nbsp&nbsp 技术支持：杭州互办网络科技有限公司",
      // url:"http://115.29.185.211:8033/huban-dcfadmin/modules/app/im.html",
      url:"http://101.37.39.157:8080/huban-dcfadmin/modules/app/im.html",
      user:"",
      token:"",
      id:"",
      username:"",
      isSelect: 1,
      isEndLogin: true,
      currentNum: 1,
      loginAdmin:"",
      loginPassword:"",
      registerAdmin:"",
      checkNum:"",
      registerPassword:"",
      aginPassword:"",
      forgetAdmin:"",
      checkNum:"",
      forgetPassword:"",
      forgetAginPassword:"",
      chooseAll: true, //true记住密码
      isforget: false,
      newImageUrl: require("../assets/head.jpg")
    };
  },

  methods: {
    rememberPw() {
      this.chooseAll = !this.chooseAll;
      if (this.chooseAll) {
        // alert("记住密码");
      }
    },
    // 返回首页
    backToIndex() {
      let flag = 1;
      sessionStorage.setItem("flag", JSON.stringify(flag));
      this.isEndLogin = true;
      document
        .getElementsByClassName("communication")[0]
        .classList.remove("myNewstyle");
    },
    // 选择登陆模块
    // notRegister() {
    //   this.isSelect = 1;
    //   this.currentNum = 1;
    // },
    // 选择注册模块
    // isRegister() {
    //   this.isSelect = 2;
    //   this.currentNum = 2;
    // },
    // 获取验证码  /api/login/code/{userName}/{type} type=1为注册 2为忘记密码
    getKey(type, registerAdmin) {
      //////console.log(type);
      ////console.log(registerAdmin);
      // 验证手机号  0?(13|14|15|17|18)[0-9]{9}
      // let myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
      // //console.log(myreg.test(registerAdmin));
      // if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(registerAdmin))) {
      //   alert("手机号格式错误");
      //   return false;
      // } else {
      this.$axios
        .get(this.$http + "api/login/code/" + registerAdmin + "/" + type)
        .then(res => {
          //console.log(res);
          if (res.data.code == 500) {
            // alert(res.data.msg);
            this.$notify({
              title: "提示信息",
              message: res.data.msg,
              type: "warning"
            });
          } else if (res.data.code == 0) {
            // alert(res.data.msg);
            this.$notify({
              title: "成功",
              message: res.data.msg,
              type: "success"
            });
          } else {
            // alert(res.data.msg);
            this.$notify.error({
              title: "错误",
              message: res.data.msg
            });
          }
        })
        .catch(err => {});
      // }
    },
    // 注册 /api/login/save
    register() {
      //console.log("444");
      if (this.registerPassword == this.aginPassword) {
        //console.log(this.checkNum, this.registerPassword, this.registerAdmin);
        let obj = {
          code: this.checkNum,
          passWord: this.registerPassword,
          userName: this.registerAdmin
        };
        let data = JSON.stringify(obj);
        this.$axios({
          method: "post",
          url: this.$http + "api/login/save",
          headers: {
            "Content-Type": "application/json"
          },
          data: data
        })
          .then(res => {
            //console.log(res);
            if (res.data.code == 0) {
              // alert("注册成功");
              this.$notify({
                title: "成功",
                message: "注册成功",
                type: "success"
              });
              this.loginPassword = this.registerPassword;
              this.loginAdmin = this.registerAdmin;
              this.loginEvent();
              // this.isEndLogin = true;
            } else {
              // alert(res.data.msg);
              this.$notify({
                title: "失败",
                message: res.data.msg,
                type: "warning"
              });
            }
          })
          .catch(err => {});
      } else {
        // alert("密码不一致，请重新输入！");
        this.$notify.error({
          title: "错误",
          message: "密码不一致，请重新输入！"
        });
      }
    },
    // /api/login/wantUpd忘记密码
    forget() {
      //console.log("444");
      if (this.forgetPassword == this.forgetAginPassword) {
        let obj = {
          code: this.checkNum,
          passWord: this.forgetPassword,
          userName: this.forgetAdmin
        };
        let data = JSON.stringify(obj);
        this.$axios({
          method: "post",
          url: this.$http + "api/login/wantUpd",
          headers: {
            "Content-Type": "application/json"
          },
          data: data
        })
          .then(res => {
            if (res.data.code == 0) {
              // alert("修改成功");
              this.$notify({
                title: "成功",
                message: "修改成功",
                type: "success"
              });
              this.isSelect = 1;
            } else {
              // alert(res.data.msg);
              this.$notify({
                title: "失败",
                message: res.data.msg,
                type: "warning"
              });
            }
          })
          .catch(err => {});
      } else {
        // alert("密码不一致，请重新输入！");
        this.$notify.error({
          title: "错误",
          message: "密码不一致，请重新输入！"
        });
      }
    },
    // 登陆/api/login/login登陆  传入账号userName密码passWord
    loginEvent() {
      let obj = {
        passWord: this.loginPassword,
        userName: this.loginAdmin
      };
      //console.log(obj);
      let data = JSON.stringify(obj);
      this.$axios({
        method: "post",
        url: this.$http + "api/login/login",
        headers: {
          "Content-Type": "application/json"
        },
        data: data
      })
        .then(res => {
          if (res.data.code == 0) {
            if (this.chooseAll) {
              // alert("记住密码");
              localStorage.setItem("userZhPw", JSON.stringify(obj));
              //console.log("这是记住的密码" + localStorage.getItem("userZhPw"));
            } else {
              localStorage.setItem("userZhPw", "");
            }
            //console.log(res);
            this.user = res.data.user;
            sessionStorage.setItem("user", JSON.stringify(this.user));
            // //console.log("登陆成功");
            this.$notify({
              title: "成功",
              message: "登陆成功",
              type: "success"
            });
            //console.log($('.communication').eq(0))
            // //console.log(document.getElementsByClassName("communication")[0].classList);
           
            // this.$router.back(-1);
            let flag = 1;
            sessionStorage.setItem("flag", JSON.stringify(flag));
            sessionStorage.setItem("userName", JSON.stringify(res.data.user));
            
            // this.isLogin = false;
            // this.isEndLogin = true;
            this.isEndLogin = true;
            document
              .getElementsByClassName("communication")[0]
              .classList.remove("myNewstyle");
              $('.communication').addClass('123')
              this.user=JSON.parse(sessionStorage.getItem("user")) ;
              this.token=this.user.udid;
              this.id=this.user.userId;
              this.username=this.user.userName;
              this.reload();
          } else {
            // //console.log("登陆失败");
            // alert(res.data.msg);
            this.$notify({
              title: "失败",
              message: res.data.msg,
              type: "warning"
            });
          }
        })
        .catch(err => {});
    },
    // 选择头像
    beforeAvatarUpload(file) {
      //console.log("选择头像");
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    // 上传头像成功回调
    handleAvatarSuccess(res, file) {
      //console.log(res, file);
      if (res.code == 0) {
        this.imageUrl = URL.createObjectURL(file.raw);
        // alert("上传成功");
        this.$notify({
          title: "成功",
          message: "上传成功",
          type: "success"
        });
      }
    },
    // 取消登陆
    cancelLogin() {
      // this.isLogin = false;
      this.isEndLogin = true;
      document
        .getElementsByClassName("communication")[0]
        .classList.remove("myNewstyle");
    },
    // 选择登陆模块
    notRegister() {
      this.isSelect = 1;
      this.currentNum = 1;
    },
    // 选择注册模块
    isRegister() {
      this.isSelect = 2;
      this.currentNum = 2;
    },
    nowToRegister() {
      this.isSelect = 2;
      this.currentNum = 2;
    },
    // 忘记密码
    forgetPasswordEvent() {
      this.isSelect = 3;
    },
    select(selectFlag) {
      //console.log("111");
      document.getElementsByClassName("communication")[0].classList.add("myNewstyle");
      this.isSelect = selectFlag;
      this.isEndLogin = false;
      if (this.isSelect == 1) {
        this.currentNum = 1;
      } else {
        this.currentNum = 2;
      }
    },
  },

  created() {
    //console.log(this.currentNum);
  },
  mounted(){
    if(sessionStorage.getItem("user")){
      this.user=JSON.parse(sessionStorage.getItem("user")) ;
      this.token=this.user.udid;
      this.id=this.user.userId;
      this.username=this.user.userName;
      //console.log(this.token,this.id,this.username);
    }else{
      // this.$notify({
      //     title: "温馨提示",
      //     message: "您还没有登录交流圈，请先登录",
      //     type: "warning"
      //   });
      var flag=null;
      sessionStorage.setItem("flag",flag)
      // this.$router.push("/");
    }
    //console.log(this.user);
    if (sessionStorage.getItem("flag") == "null") {
      //console.log("111");
      this.isLogin = 1;
      this.isEndLogin = false;
      document.getElementsByClassName("communication")[0].classList.add("myNewstyle");
    }
    if (localStorage.getItem("userZhPw")) {
      this.loginAdmin = JSON.parse(localStorage.getItem("userZhPw")).userName;
      this.loginPassword = JSON.parse(
        localStorage.getItem("userZhPw")
      ).passWord;
      // //console.log(
      //   "这是上次登录记住的密码" + this.loginAdmin,
      //   this.loginPassword
      // );
    }
    //console.log(this.isEndLogin);
  },
  watch:{
    isEndLogin:{
      handler:function(newVal,oldVal){
        //console.log('isEndLogin:'+newVal)
        if(newVal){
          //console.log($('.communication'))
        }
      },
      deep:true
    }
  }
};
</script>

<style>
.communication {
  height: 100vh;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center center;
}
.loginEnd{
  background-image: url("../assets/bg0.png");
}
.communication .navTab {
  box-shadow: 0px 4px 8px 0px rgba(102, 102, 102, 0.2);
  z-index:999;
}
#screen{
  width: 90%;
  height: 80%;
  /* background-color: pink; */
  margin: 0 auto;
}
/* .communication .address {
  width: 100%;
  text-align: center;
  margin: 0 auto;
  font-size: 12px;
  color: #fff;
  position: fixed;
  bottom: 32px;
} */
.communication .style {
  color: #158DD3;
  border-bottom: 2px solid #158DD3;
  /* text-decoration: underline; */
}
.communication .loginPart {
  /* width: 830px; */
  width: 900px;
  /* height: 38%; */
  /* background: #fff; */
  background-image: url("../assets/loginbj.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  border-radius: 30px;
  /* margin: 0 auto;
  margin-top: 5%; */
  /* margin: 0 auto; */
  position: absolute;
  /* top: 10%;
  left: 50%;
  transform: translateX(-50%) scale(0.8); */
  top: 23%;
  left: 50%;
  transform: translate(-50%, 0%) scale(0.7);
  z-index: 10;
  padding: 0 0;
  padding-bottom: 4%;
  /* position: relative; */
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-radius: 10px;
}
.communication .onlyLef {
  position: relative;
  width: 55%;
}
.communication .loginPart .loginHead {
  height: 360px;
  width: 360px;
  overflow: hidden;
  border-radius: 50%;
  margin: 20px auto;
  /* border: 1px solid #b5b4b4; */
  /* margin-bottom: 20px; */
  text-align: center;
  /* line-height: 50px; */
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.communication .loginPart .loginHead img {
  display: block;
  width: 100%;
  height: 100%;
}
.communication .backIndexDiv {
  position: absolute;
  left: 30px;
  bottom: -36px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  cursor: pointer;
}
.communication .backIndexDiv img {
  display: block;
  height: 23px;
  width: 23px;
}
.communication .backIndexDiv p {
  font-size: 16px;
  font-family: MicrosoftYaHei;
  font-weight: bold;
  color: #158DD3;
  margin-left: 10px;
}
.communication .onlyRig {
  position: relative;
  width: 38%;
  background-color: rgba(255, 255, 255, 0.6) !important;
  margin-top: 8%;
  margin-right: 3%;
  padding: 30px 0;
}
.communication .loginPart .loginNav {
  width: 100%;
  height: 50px;
  line-height: 50px;
  color: black;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.communication .loginPart .loginNav li {
  height: 86%;
  cursor: pointer;
  text-align: center;
  /* width: 52px; */
  /* width: 100%; */
  font-size: 16px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  margin: 0 10%;
  font-size: 22px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
}
.communication .loginPart .loginNav li:hover {
  /* color: #158DD3; */
  border-bottom: 2px solid #158DD3;
  /* text-decoration: underline; */
}
.communication .style {
  color: #158DD3;
  border-bottom: 2px solid #158DD3;
  /* text-decoration: underline; */
}
.communication .loginPart .loginInput {
  width: 90%;
  margin: 0 auto;
}
.communication .loginPart .loginInput li {
  height: 48px;
  /* background: black; */
  margin: 12% 0;
  border: 1px solid #b5b4b4;
  border-radius: 24px;
  padding: 0 22px;
}
.communication .loginPart .loginInput li input {
  padding-left: 3px;
  width: 100%;
  height: 100%;
  background-color: transparent;
  border: 0;
  color: rgb(32, 32, 32);
  outline: none;
  font-size: 14px;
  /* 控制文字之间的间距 */
  letter-spacing: 1px;
}
.communication input::-webkit-input-placeholder,
textarea::-webkit-input-placeholder {
  color: #b5b4b4;
}

.communication input:-moz-placeholder,
textarea:-moz-placeholder {
  color: #b5b4b4;
}

.communication input::-moz-placeholder,
textarea::-moz-placeholder {
  color: #b5b4b4;
}

.communication input:-ms-input-placeholder,
textarea:-ms-input-placeholder {
  color: #b5b4b4;
}
.communication .loginPart .newDiv {
  width: 90%;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  /* background-color: purple; */
}
.communication .loginPart .newDiv .newDivLeft {
  /* display: flex;
  flex-direction: row;
  justify-content: flex-start; */
  font-size: 14px;
  width: 150px;
  position: relative;
  height: 18px;
}
.communication .loginPart .newDiv .newDivLeft input {
  width: 10px;
  height: 10px;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
}
.communication .loginPart .newDiv .newDivLeft p {
  position: absolute;
  top: 50%;
  left: 15px;
  transform: translateY(-50%);
}
.communication .loginPart .forgetPassword {
  display: block;
  text-align: right;
  width: 150px;
  /* width: 200px; */
  height: 15px;
  font-size: 14px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: #158DD3;
  /* margin-left: 60%; */
  /* margin-top: 6%; */
  cursor: pointer;
}
.communication .loginPart .loginBtn {
  width: 90%;
  height: 50px;
  text-align: center;
  line-height: 50px;
  color: rgba(255, 255, 255, 1);
  background: #158DD3;
  margin: 0 auto;
  margin-top: 5%;
  border-radius: 25px;
  cursor: pointer;
  font-size: 14px;
  margin-bottom: 20px;
}
.communication #forget {
  width: 40%;
  cursor: default;
}
.communication #forget:hover {
  color: #b5b4b4;
  border: 0;
}
.communication.top .phone {
  display: block;
  width: 12%;
  height: 97%;
  position: absolute;
  right: 25%;
  top: 10%;
}
.communication .newP {
  width: 100%;
  text-align: center;
  font-size: 12px;
  color: #827e7e;
  margin-bottom: 30px;
  font-family: MicrosoftYaHei;
  cursor: pointer;
}
.communication #newSpan {
  color: #158DD3;
}
.communication .loginPart .loginHead {
  height: 360px;
  width: 360px;
  overflow: hidden;
  border-radius: 50%;
  margin: 20px auto;
  /* border: 1px solid #b5b4b4; */
  /* margin-bottom: 20px; */
  text-align: center;
  /* line-height: 50px; */
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.communication .loginPart .loginHead img {
  display: block;
  width: 100%;
  height: 100%;
}
.communication #getKey {
  width: 40%;
  background-color: #158DD3;
  margin: 0 auto;
  height: 33px;
  line-height: 33px;
  cursor: pointer;
  /* border-radius: 3px; */
  color: #ffffff;
  border: 0;
  font-size: 14px;
  /* text-decoration: underline; */
  border-bottom: 1px solid #b5b4b4;
}
 .communication .myNewstyle {
  /* background-image: url("../assets/bg.png"); */
  /* background: rgba(231, 240, 255, 1); */
  background-color: rgba(231, 240, 255, 1) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/communication.vue